import { AnimatePresence, motion } from 'framer-motion';

export default function InlineToast({ show, message, type = 'success' }) {
  const color =
    type === 'success' ? 'bg-green-600' : type === 'error' ? 'bg-red-600' : 'bg-gray-800';

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 8 }}
          transition={{ duration: 0.25 }}
          className={`
            absolute -top-12 right-0
            px-3 py-2 rounded-lg text-white text-xs
            shadow-lg z-40 whitespace-nowrap ${color}
          `}
        >
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
